// extracted by mini-css-extract-plugin
export default {"profile-picture":"ProfilePicture_profile-picture__ZXIiU","profile-initials":"ProfilePicture_profile-initials__KXPJB"};